// extracted by mini-css-extract-plugin
module.exports = {"container":"Test_container__3Rutj","form-container":"Test_form-container__11M4S"};